import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const fetchDashboardStats = () => api.get("/dashboard/stats").then(r => r.data);
export const fetchDashboardKpis = () => api.get("/dashboard/kpis").then(r => r.data);
export const fetchTrends = () => api.get("/trends").then(r => r.data);
export const fetchCategoryTrends = (cat) => api.get(`/trends/${cat}`).then(r => r.data);
export const fetchAlerts = (params) => api.get("/alerts", { params }).then(r => r.data);
export const markAlertRead = (id) => api.post(`/alerts/${id}/read`).then(r => r.data);
export const markAllAlertsRead = () => api.post("/alerts/read-all").then(r => r.data);
export const fetchAlertConfig = () => api.get("/alerts/config").then(r => r.data);
export const updateAlertConfig = (config) => api.put("/alerts/config", config).then(r => r.data);
export const fetchCompetitorPages = (params) => api.get("/competitors/pages", { params }).then(r => r.data);
export const fetchCompetitorStats = () => api.get("/competitors/stats").then(r => r.data);
export const fetchBrandRadar = (params) => api.get("/brand-radar", { params }).then(r => r.data);
export const fetchSocialPosts = (params) => api.get("/social/posts", { params }).then(r => r.data);
export const fetchSocialChart = (params) => api.get("/social/chart", { params }).then(r => r.data);
export const fetchSocialStats = () => api.get("/social/stats").then(r => r.data);
export const fetchSocialTrending = (params) => api.get("/social/trending", { params }).then(r => r.data);
export const fetchRecommendations = (params) => api.get("/recommendations", { params }).then(r => r.data);
export const refreshRecommendations = () => api.post("/recommendations/refresh").then(r => r.data);
export const updateRecommendation = (recId, action) => api.patch(`/recommendations/${recId}?action=${action}`).then(r => r.data);
export const fetchContentOpportunities = (params) => api.get("/content-opportunities", { params }).then(r => r.data);
export const sendChatMessage = (message, sessionId) => api.post("/chat", { message, session_id: sessionId }).then(r => r.data);
export const fetchSettings = () => api.get("/settings").then(r => r.data);

// Dairy Intelligence
export const fetchDairyPosts = (params) => api.get("/dairy/posts", { params }).then(r => r.data);
export const fetchDairyStats = () => api.get("/dairy/stats").then(r => r.data);
export const fetchDairyChart = (params) => api.get("/dairy/chart", { params }).then(r => r.data);
export const fetchDairySummary = () => api.get("/dairy/summary").then(r => r.data);
export const refreshDairySummary = () => api.post("/dairy/summary/refresh").then(r => r.data);

export const getExportUrl = (params) => {
  const qs = new URLSearchParams(params).toString();
  return `${API}/export/csv${qs ? '?' + qs : ''}`;
};

export const SOCIAL_CATEGORIES = {
  jbtv: 'TVs', jblaptop: 'Laptops', jbphones: 'Phones',
  jbtablets: 'Tablets', jbheadphones: 'Headphones', jbsmarthomes: 'Smart Home'
};

export const SOCIAL_CAT_COLORS = {
  jbtv: '#3B82F6', jblaptop: '#8B5CF6', jbphones: '#10B981',
  jbtablets: '#F59E0B', jbheadphones: '#EF4444', jbsmarthomes: '#06B6D4',
  general: '#6B7280'
};

export const TAG_NAMES = {
  jbtv: 'TVs', jbmobile: 'Mobile', jblaptop: 'Laptops',
  jbcomputer: 'Computers', jbheadphones: 'Headphones',
};

export const TAG_COLORS = {
  jbtv: '#3B82F6', jbmobile: '#10B981', jblaptop: '#8B5CF6',
  jbcomputer: '#F59E0B', jbheadphones: '#EF4444',
};

export const COMPETITOR_COLORS = {
  'jbhifi.com.au': '#FFEE2F',
  'thegoodguys.com.au': '#3B82F6',
  'harveynorman.com.au': '#EF4444',
  'officeworks.com.au': '#10B981'
};

export const DAIRY_THEME_NAMES = {
  protein_source: 'Dairy as Protein',
  health_benefits: 'Health Benefits',
  health_concerns: 'Health Concerns',
  dairy_farmers: 'Dairy Farmers',
  milk_price: 'Milk Price & Availability',
  general_dairy: 'General',
};

export const DAIRY_THEME_COLORS = {
  protein_source: '#10B981',
  health_benefits: '#3B82F6',
  health_concerns: '#EF4444',
  dairy_farmers: '#F59E0B',
  milk_price: '#8B5CF6',
  general_dairy: '#6B7280',
};
